




































import Vue from "vue"
import {ShipmentIdCheck} from "@/model/entity/shipment/shipment-id-check"
import {CreateParcelModel} from "@/model/new-parcel-model/create-parcel-model"

export interface IIdCheckGroup extends Vue {
  getIdCheck(): ShipmentIdCheck

  setIdCheck(shipmentIdCheck: ShipmentIdCheck): void

  clearAll(): void
}

export default Vue.extend({
  data() {
    return {
      form: {
        receiverName: "",
        idLastChars: ""
      },
      rules: {
        receiverName: [{
          required: true, message: this.$t("new.parcel.error.id_check.id_receiver").toString(),
          trigger: "change"
        }]
      }
    }
  },
  props: {
    createParcelModel: {
      type: CreateParcelModel,
      required: true
    },
    idCheckValidated: {
      type: Boolean,
      required: true
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearAll() {
      this.form = {
        receiverName: "",
        idLastChars: ""
      }
    },
    getIdCheck(): ShipmentIdCheck {
      return new ShipmentIdCheck(this.form.receiverName, this.form.idLastChars)
    },
    setIdCheck(shipmentIdCheck: ShipmentIdCheck) {
      this.form.receiverName = shipmentIdCheck.receiverName
      this.form.idLastChars = shipmentIdCheck.idNum
    },
    emitValidation() {
      this.$emit(
        "update:idCheckValidated",
        !this.createParcelModel.createParcelModelOptions.idCheck.value ||
        (exists(this.form.receiverName) &&
          this.form.receiverName !== "" &&
          this.createParcelModel.createParcelModelOptions.idCheck.value)
      )
    }
  },
  watch: {
    "form.receiverName": {
      handler() {
        this.emitValidation()
      }
    },
    "createParcelModel.createParcelModelOptions.idCheck.value": {
      handler() {
        this.emitValidation()
      }
    }
  },
  mounted() {
    this.emitValidation()
  }
})
